import SystemSettings from "./systemSettings";
import vue from "../../main";

export default class SystemSettingsFUll extends SystemSettings {
  constructor() {
    super();

    this.delegation_vehicle_under_900_rate = null;
    this.delegation_vehicle_above_900_rate = null;
    this.delegation_vehicle_moped_rate = null;
    this.delegation_vehicle_motorcycle_rate = null;

    this.google_maps_distance_matrix_api_key = null;
    this.google_maps_api_geocoding_api_key = null;
    this.google_maps_places_api_key = null;

    this.delegation_google_distance_verification = null;
    this.delegation_google_distance_verification_allowed_difference = null;
    this.is_allowed_multiple_delegation_advance = null;
    this.delegation_number_date = null;
    this.delegation_number_setting_type = null;
    this.delegation_number_template = null;

    this.delegation_from_order_date_validation_type = null;
    this.delegation_from_order_date_change = null;
    this.delegation_from_order_country_change = null;
    this.delegation_from_order_transport_change = null;
    this.delegation_from_order_destination_change = null;
    this.delegation_from_order_cost_centre_change = null;
    this.delegation_from_order_start_end_location_change = null;
    this.delegation_order_confirm_is_required = null;
    this.delegation_order_number_date = null;
    this.delegation_order_number_template = null;
    this.delegation_order_number_setting_type = null;
    this.mileage_for_non_private_vehicles = null;

    this.document_language = null;
    this.other_transport_comment_required = null;

    this.transport_attachment_required = null;
    this.accommodation_attachment_required = null;
    this.other_cost_account_number_required = null;
    this.transport_already_settled_comment_required = null;
    this.accommodation_already_settled_comment_required = null;

    this.delegation_emails = null;
    this.cost_centre_on_delegations = null;

    this.external_customers_module = null;
    this.delegation_settlement_document_view = null;
    this.pdf_attachment_only = null;
    this.password_expiration = null;
    this.allowed_report_types = [];
    this.allowed_report_file_formats = [];

    this.access_from_non_blocked_ip = null;
    this.ip_whitelist = [];
    this.ip_blacklist = [];

    this.delegation_advance_flow = null;
    this.delegation_settlement_document_copy_delegation_order = null;

    this.block_after_failed_try = null;
    this.block_after_failed_try_time = null;
    this.session_time = null;
    this.minimum_password_length = null;
    this.lower_letters_required_in_password = null;
    this.upper_letters_required_in_password = null;
    this.digits_required_in_password = null;
    this.special_characters_required_in_password = null;
    this.translations_modifications = null;
    this.is_delegation_task_enabled = null;

    this.delegation_number_template_rules = [() => this.validateTemplateMask()];
    this.is_synchro_numbers = false;
  }

  load(userId, groupId = null, loadUrl = "settings/system/get-full") {
    this.groupId = groupId;
    vue.axios.post(loadUrl, { id: userId }).then(resp => {
      this.delegation_vehicle_under_900_rate = resp.data.delegation_vehicle_under_900_rate;
      this.delegation_vehicle_above_900_rate = resp.data.delegation_vehicle_above_900_rate;
      this.delegation_vehicle_moped_rate = resp.data.delegation_vehicle_moped_rate;
      this.delegation_vehicle_motorcycle_rate = resp.data.delegation_vehicle_motorcycle_rate;

      this.google_maps_distance_matrix_api_key = resp.data.google_maps_distance_matrix_api_key;
      this.google_maps_api_geocoding_api_key = resp.data.google_maps_api_geocoding_api_key;
      this.google_maps_places_api_key = resp.data.google_maps_places_api_key;

      this.delegation_google_distance_verification = resp.data.delegation_google_distance_verification;
      this.delegation_google_distance_verification_allowed_difference = resp.data.delegation_google_distance_verification_allowed_difference;
      this.is_allowed_multiple_delegation_advance = resp.data.is_allowed_multiple_delegation_advance;
      this.delegation_number_date = resp.data.delegation_number_date;
      this.delegation_number_setting_type = resp.data.delegation_number_setting_type;
      this.delegation_number_template = resp.data.delegation_number_template;

      this.delegation_from_order_date_validation_type = resp.data.delegation_from_order_date_validation_type;
      this.delegation_from_order_date_change = resp.data.delegation_from_order_date_change;
      this.delegation_from_order_country_change = resp.data.delegation_from_order_country_change;
      this.delegation_from_order_transport_change = resp.data.delegation_from_order_transport_change;
      this.delegation_from_order_destination_change = resp.data.delegation_from_order_destination_change;
      this.delegation_from_order_cost_centre_change = resp.data.delegation_from_order_cost_centre_change;
      this.delegation_from_order_start_end_location_change = resp.data.delegation_from_order_start_end_location_change;
      this.delegation_order_confirm_is_required = resp.data.delegation_order_confirm_is_required;
      this.delegation_order_number_date = resp.data.delegation_order_number_date;
      this.delegation_order_number_template = resp.data.delegation_order_number_template;
      this.delegation_order_number_setting_type = resp.data.delegation_order_number_setting_type;
      this.delegation_order_type = resp.data.delegation_order_type;
      this.delegation_emails = resp.data.delegation_emails;
      this.mileage_for_non_private_vehicles = resp.data.mileage_for_non_private_vehicles;

      this.document_language = resp.data.document_language;
      this.other_transport_comment_required = resp.data.other_transport_comment_required;

      this.transport_attachment_required = resp.data.transport_attachment_required;
      this.accommodation_attachment_required = resp.data.accommodation_attachment_required;
      this.other_cost_account_number_required = resp.data.other_cost_account_number_required;
      this.allowed_transport_types = JSON.parse(resp.data.allowed_transport_types);
      this.allowed_transport_settlement = JSON.parse(resp.data.allowed_transport_settlement);
      this.allowed_accommodation_settlement = JSON.parse(resp.data.allowed_accommodation_settlement);
      this.transport_already_settled_comment_required = resp.data.transport_already_settled_comment_required;
      this.accommodation_already_settled_comment_required = resp.data.accommodation_already_settled_comment_required;
      this.cost_centre_on_delegations = resp.data.cost_centre_on_delegations;
      this.external_customers_module = resp.data.external_customers_module;
      this.delegation_settlement_document_view = resp.data.delegation_settlement_document_view;
      this.pdf_attachment_only = parseInt(resp.data.pdf_attachment_only);
      this.password_expiration = resp.data.password_expiration;
      this.allowed_report_types = JSON.parse(resp.data.allowed_report_types);
      this.allowed_report_file_formats = JSON.parse(resp.data.allowed_report_file_formats);

      this.access_from_non_blocked_ip = resp.data.access_from_non_blocked_ip;
      this.ip_whitelist = resp.data.ip_whitelist;
      this.ip_blacklist = resp.data.ip_blacklist;

      this.block_after_failed_try = resp.data.block_after_failed_try;
      this.block_after_failed_try_time = resp.data.block_after_failed_try_time;
      this.session_time = resp.data.session_time;
      this.minimum_password_length = resp.data.minimum_password_length;
      this.lower_letters_required_in_password = resp.data.lower_letters_required_in_password;
      this.upper_letters_required_in_password = resp.data.upper_letters_required_in_password;
      this.digits_required_in_password = resp.data.digits_required_in_password;
      this.special_characters_required_in_password = resp.data.special_characters_required_in_password;

      this.delegation_advance_flow = resp.data.delegation_advance_flow;
      this.delegation_settlement_document_copy_delegation_order = resp.data.delegation_settlement_document_copy_delegation_order;
      this.translations_modifications = resp.data.translations_modifications;

      this.is_delegation_task_enabled = resp.data.is_delegation_task_enabled;
      this.is_synchro_numbers = resp.data.is_synchro_numbers;
    });
  }

  save(saveUrl = "settings/system/save") {
    return new Promise((resolve, reject) => {
      let jsonedModel = JSON.parse(JSON.stringify(this));
      jsonedModel.allowed_transport_types = JSON.stringify(jsonedModel.allowed_transport_types);
      jsonedModel.allowed_transport_settlement = JSON.stringify(jsonedModel.allowed_transport_settlement);
      jsonedModel.allowed_accommodation_settlement = JSON.stringify(jsonedModel.allowed_accommodation_settlement);
      jsonedModel.allowed_report_file_formats = JSON.stringify(jsonedModel.allowed_report_file_formats);
      jsonedModel.allowed_report_types = JSON.stringify(jsonedModel.allowed_report_types);
      vue.axios
        .post(saveUrl, jsonedModel)
        .then(() => {
          resolve();
        })
        .catch(resp => {
          reject(resp.data);
        });
    });
  }

  validateTemplateMask() {
    let result = [];

    if ((this.delegation_number_setting_type === 2 || this.delegation_number_setting_type === 3) && this.delegation_number_template == null) {
      result.push(vue.$t("settings.systemSettings.inCaseOfAutoNumbersTemplateIsRequired"));
    }

    return result;
  }

  validateDelegationOrderTemplate() {
    let result = [];

    if ((this.delegation_order_number_setting_type === 2 || this.delegation_order_number_setting_type === 3) && this.delegation_order_number_template == null) {
      result.push(vue.$t("settings.systemSettings.inCaseOfAutoNumbersTemplateIsRequired"));
    }

    return result;
  }
}
